import { useEffect, useState } from 'react'
import { throttle } from 'lodash'

export default function useVisibleSection(ids: Array<string>) {
  const [visibleSection, setVisibleSection] = useState<string | undefined>()

  const isSectionVisible = (elementId: string) => {
    const section = document.getElementById(elementId)

    if (section) {
      const sectionPosition = section.getBoundingClientRect()

      const viewPort = {
        height: window.innerHeight,
        width: window.innerWidth,
      }

      return (
        sectionPosition.top >= 0 &&
        sectionPosition.left >= 0 &&
        sectionPosition.bottom <= viewPort.height / 2 &&
        sectionPosition.right <= viewPort.width
      )
    }

    return false
  }

  const checkVisibility = () => {
    for (const id of ids) {
      if (isSectionVisible(id)) {
        setVisibleSection(id)
        break
      }
    }
  }

  useEffect(() => {
    if (ids) {
      window.addEventListener('scroll', throttle(checkVisibility, 300))
    }

    checkVisibility()

    return () =>
      window.addEventListener('scroll', throttle(checkVisibility, 300))
  }, [])

  return visibleSection
}
